// SCHOOL-SPECIFIC — Happee English Club. See src/config/school.js.
export const happee = {
  key: 'happee',
  name: 'Happee',
  appName: 'Library',

  // Feeds member and copy codes (HAP-BC-000123). MUST match app_config.short_code
  // in THIS brand's database — a SEPARATE Supabase project from Heguru's.
  // Changing it after labels are printed invalidates every label.
  shortCode: 'HAP',

  // Only used to build the example in the "scan or type a book code" hint.
  // Baby City is the one branch, so a 'B1' example would be a code that does
  // not exist in this building.
  exampleBranchCode: 'BC',

  // Branch name used by demo mode (VITE_MOCK) — screenshots and walkthroughs.
  demoBranchName: 'Baby City',

  currency: 'MMK',
  timezone: 'Asia/Yangon',

  // The address staff type to reach THIS school's app. Printed on the cover of
  // the staff guide and repeated in the install steps — the guide's own
  // "use only this address" warning is worthless if the address is wrong.
  liveUrl: 'library.happeemyanmar.com',

  brand: {
    // Sampled from this brand's logo.png — the "Happ" green, 2.8% of all pixels
    // and the largest saturated group. Re-sample with: npm run brand:color
    color: '#00b968',

    // The "English Club" wordmark black. Also the readable text colour on the
    // brand green, which is too light for white text (see lib/theme.js).
    ink: '#000000',

    logo:  '/brand/happee/logo.png',
    mark:  '/brand/happee/mark.png',
    icons: '/icons/happee',

    // The lockup is one horizontal piece — the green bounding box would clip
    // the yellow "ee", so the header mark is cropped by band instead of by
    // colour. See scripts/generate-icons.mjs.
    generateMark: false,
    markBand: [0, 0.71],   // top 71% of the trimmed logo: wordmark + smile,
                           // without the "English Club" sub-line.
  },
};
